import { NgModule } from '@angular/core';

import {ActivityDashboardRoutesModule} from './activity-dashboard.routes';
import { ActivityDashboardComponent } from './activity-dashboard.component';
import { BaseModule } from '../shared/base.module';
import { PaginationModule } from '../shared/pagination/pagination.module';
import {SharedPopoverModule} from "../shared/popover/popover.module";
import {MatSelectModule} from "@angular/material/select";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {Daterangepicker} from "ng2-daterangepicker";
import {NgSelect2Module} from "ng-select2";
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    imports: [
        BaseModule,
        ActivityDashboardRoutesModule,
        PaginationModule,
        BsDropdownModule.forRoot(),
        MatSelectModule,
        SharedPopoverModule,
        NgSelect2Module,
        Daterangepicker,
        BreadcrumbModule,
        MatSlideToggleModule
    ],
    declarations: [
        ActivityDashboardComponent
    ]
})
export class ActivityDashboardModule { }
